/**
 * EmptyState — centered empty/no-data treatment.
 *
 * Pattern: py 48px, icon 32px in muted circle (48x48), title 16/600,
 * description 14 muted max-w 360px, optional CTA below at 16px gap.
 */
export const EmptyState = ({ icon: Icon, title, message, action }) => (
  <div className="flex flex-col items-center justify-center text-center py-12 px-4">
    {Icon && (
      <div
        className="w-12 h-12 rounded-full flex items-center justify-center mb-4"
        style={{ background: 'rgba(20,20,20,0.04)' }}
        aria-hidden="true"
      >
        <Icon size={20} strokeWidth={1.6} className="text-lb-muted" />
      </div>
    )}
    {title && (
      <h3 className="text-[16px] font-semibold text-lb-ink-strong leading-[1.3] m-0">{title}</h3>
    )}
    {message && (
      <p className="text-[14px] text-lb-muted leading-[1.5] mt-2 max-w-[360px] m-0">
        {message}
      </p>
    )}
    {action && <div className="mt-4">{action}</div>}
  </div>
);
